module.exports = __webpack_public_path__ + "static/media/image-category-icon.49e3e278.svg";